export class CropperDrawSettings {
    public strokeWidth: number = 1;
    public strokeColor: string = 'rgba(255,255,255,1)';
    public dragIconStrokeWidth: number = 1;
    public dragIconStrokeColor: string = 'rgba(0,0,0,1)';
    public dragIconFillColor: string = 'rgba(255,255,255,1)';
}
